import { useEffect } from 'react';

const setMeta = (selector, attr, value) => {
  if (!value) return;
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement('meta');
    // parse selector like meta[name="description"] or meta[property="og:title"]
    const match = selector.match(/\[([a-z-]+)="([^"]+)"\]/i);
    if (match) el.setAttribute(match[1], match[2]);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
};

const setLinkRel = (rel, href) => {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
};

/**
 * Applies SEO meta tags from the CMS-backed content.seo block to the current document.
 * Should be mounted once on the public site.
 */
export const SeoHead = ({ seo, brand }) => {
  useEffect(() => {
    if (!seo) return;
    const s = seo?.extra || {};
    if (s.meta_title) document.title = s.meta_title;
    setMeta('meta[name="description"]', 'content', s.meta_description);
    setMeta('meta[name="keywords"]', 'content', s.meta_keywords);
    setMeta('meta[name="robots"]', 'content', s.robots || 'index, follow');
    setMeta('meta[property="og:title"]', 'content', s.og_title || s.meta_title);
    setMeta('meta[property="og:description"]', 'content', s.og_description || s.meta_description);
    setMeta('meta[property="og:image"]', 'content', s.og_image);
    setMeta('meta[property="og:type"]', 'content', 'website');
    setMeta('meta[name="twitter:card"]', 'content', 'summary_large_image');
    setMeta('meta[name="twitter:site"]', 'content', s.twitter_handle);
    setMeta('meta[name="twitter:title"]', 'content', s.og_title || s.meta_title);
    setMeta('meta[name="twitter:description"]', 'content', s.og_description || s.meta_description);
    setMeta('meta[name="twitter:image"]', 'content', s.og_image);
    if (s.canonical_url) setLinkRel('canonical', s.canonical_url);

    // Favicon from brand logo
    const favicon = brand?.extra?.logo_data_url;
    if (favicon) setLinkRel('icon', favicon);
  }, [seo, brand]);

  return null;
};

export default SeoHead;
